import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box/Box';
import Typography from '@mui/material/Typography/Typography';

import { breakpoints, devices } from './breakpoints';

export const BlockContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '0%',
  transform: 'translate(0, -50%)',
  zIndex: 8,

  [theme.breakpoints.down(breakpoints.sm)]: {
    top: '30%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '400px',
  },

  [theme.breakpoints.down(breakpoints.xs)]: {
    top: '48px',
    left: '16px',
    transform: 'translate(0, 0)',
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  textTransform: 'uppercase',
  color: '#FFCD2A',

  [theme.breakpoints.down(breakpoints.lg)]: {
    fontSize: '14px',
  },

  [theme.breakpoints.down(breakpoints.sm)]: {
    fontSize: '16px',
  },

  [theme.breakpoints.down(breakpoints.xs)]: {
    fontSize: '12px',
    lineHeight: '150%',
  },
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  letterSpacing: '1px',
  fontSize: '72px',
  lineHeight: '120%',
  color: '#FFFFFF',
  maxWidth: '600px',

  [theme.breakpoints.down(breakpoints.lg)]: {
    fontSize: '48px',
    maxWidth: '410px',
  },

  [theme.breakpoints.down(breakpoints.md)]: {
    fontSize: '32px',
    maxWidth: '360px',
  },

  [theme.breakpoints.down(breakpoints.sm)]: {
    fontSize: '48px',
    maxWidth: '400px',
  },

  [theme.breakpoints.down(breakpoints.xs)]: {
    fontSize: '40px',
    maxWidth: '340px',
  },
}));

export const Description = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '18px',
  lineHeight: '140%',
  marginTop: '24px',
  marginBottom: '36px',
  maxWidth: '600px',
  color: '#FFFFFFCC',

  [theme.breakpoints.down(breakpoints.lg)]: {
    maxWidth: '410px',
  },

  [theme.breakpoints.down(breakpoints.md)]: {
    marginTop: '16px',
    marginBottom: '36px',
    fontSize: '16px',
    maxWidth: '400px',
  },

  [theme.breakpoints.down(breakpoints.sm)]: {
    marginTop: '16px',
    marginBottom: '16px',
    fontSize: '16px',
    maxWidth: '343px',
  },

  [theme.breakpoints.down(breakpoints.xs)]: {
    marginTop: '16px',
    marginBottom: '16px',
    fontSize: '16px',
    maxWidth: '340px',
  },
}));

export const WebImageWrapper = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;

  img {
    max-width: 400px;
    display: block;

    @media (${devices.md}) {
      max-width: 600px;
    }

    @media (${devices.xl}) {
      max-width: 800px;
    }
  }
`;

export const RevertWebImageWrapper = styled(Box)`
  position: absolute;
  bottom: 0;
  right: 0;

  img {
    max-width: 400px;
    display: block;

    @media (${devices.md}) {
      max-width: 600px;
    }

    @media (${devices.xl}) {
      max-width: 800px;
    }
  }
`;
